import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import IMenu from '../../Interfaces/Auth/IMenu'
import { RootState } from '../../store/store'
import Logo from '../../images/logo.png'

interface Isubmenu {
  menu: IMenu[]
  descripcion: string
}

function Submenu({ descripcion, menu }: Isubmenu) {
  return (
    <div>
      <NavDropdown title={descripcion} id='basic-nav-dropdown'>
        {menu
          .filter((item) => {
            return item.descripcion.length > 2
          })
          .map((item, index) => {
            return (
              <NavDropdown.Item key={item.id} to={item.url} as={Link}>
                {item.descripcion}
              </NavDropdown.Item>
            )
          })}
      </NavDropdown>
    </div>
  )
}

function AOLNavbar() {
  const UserLogued = useSelector((state: RootState) => state.UserProfile.UserProfile.logueado)
  const User = useSelector((state: RootState) => state.UserProfile.UserProfile.User)
  const Menu = useSelector((state: RootState) => state.MenuItems.MenuItems)

  return (
    <Navbar bg='light' style={{ visibility: UserLogued === true ? 'visible' : 'hidden' }}>
      <Container>
        <Navbar.Brand to='/' as={Link}>
          <img src={Logo} alt='' height='30' />
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='me-auto'>
            {Menu
              ? Menu.map((itemMenu, index) => {
                  if (itemMenu.padreId === 0 && itemMenu.descripcion.length > 2) {
                    return (
                      <>
                        <Submenu
                          descripcion={itemMenu.descripcion}
                          key={itemMenu.id}
                          menu={Menu.filter(function (item) {
                            return item.padreId === itemMenu.id && item.descripcion.length > 2
                          })}
                        />
                      </>
                    )
                  }
                })
              : ''}
          </Nav>
        </Navbar.Collapse>
        <Navbar.Collapse className='justify-content-end'>
          {
            UserLogued ? (
              <Navbar.Text>
                Usuario: {User} - <Link to='logout'>logout</Link>
              </Navbar.Text>
            ) : null
            /*   <Link to='login'>login</Link> */
          }
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
export default AOLNavbar
